interface IProps {}

const UnhandledError: React.FC<IProps> = (props: IProps) => {
  return <h1>I believe something went wrong</h1>;
};

export default UnhandledError;
